import { useEffect } from "react";

const isOutside = (ref, target) => ref.current && !ref.current.contains(target);

// Calls `onOutsideClick` when a mousedown happens outside every ref in
// `refs` (a single ref, or an array of refs when multiple elements should
// all be treated as "inside" together — e.g. a menu button and the panel
// it opens).
export const useClickOutside = (refs, onOutsideClick) => {
  const refList = Array.isArray(refs) ? refs : [refs];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refList.every((ref) => isOutside(ref, event.target))) {
        onOutsideClick(event);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onOutsideClick, ...refList]);
};
